import React from "react";
import { Flex, Text, Icon, IconButton, Tooltip, useColorModeValue } from "@chakra-ui/react";
import { MdPeople, MdRefresh } from "react-icons/md";

/**
 * Header bar of the users list (icon badge, title, refresh button).
 * @param {object} props
 * @param {boolean} props.refreshing - Whether a refresh is in progress
 * @param {function} props.onRefresh - Callback to refresh the user list
 * @returns {React.ReactElement}
 */
function UsersListHeader({ refreshing, onRefresh, title = "Liste des Utilisateurs" }) {
    const badgeBg = useColorModeValue("brand.100", "whiteAlpha.100");
    const titleColor = useColorModeValue("secondaryGray.900", "white");
    return (
        <Flex justify="space-between" align="center" mb="16px" gap="12px" flexWrap="wrap">
            <Flex align="center" gap="12px">
                <Flex align="center" justify="center" w="44px" h="44px" borderRadius="12px" bg={badgeBg} flexShrink="0">
                    <Icon as={MdPeople} w="24px" h="24px" color="brand.500" />
                </Flex>
                <Text fontSize="0.85rem" fontWeight="700" letterSpacing="0.5px" textTransform="uppercase" color={titleColor}>
                    {title}
                </Text>
            </Flex>
            <Tooltip label="Actualiser la liste">
                <IconButton aria-label="Actualiser la liste" onClick={onRefresh} isLoading={refreshing}
                    variant="outline" colorScheme="brand" size="sm" icon={<Icon as={MdRefresh} />} />
            </Tooltip>
        </Flex>
    );
}

export default UsersListHeader;
